<template>
    <div class="quantity-badge" :class="`quantity-badge--${variant}`">
        <span class="quantity-badge__value">{{ value }}</span>
        <span v-if="label" class="quantity-badge__label">{{ label }}</span>
    </div>
</template>

<script>
export default {
    name: 'QuantityBadge',
    props: {
        value: { type: [Number, String], required: true },
        label: { type: String, default: '' },
        variant: { type: String, default: 'warning', validator: (value) => ['warning', 'error'].includes(value) }
    }
}
</script>

<style lang="scss" scoped>
.quantity-badge {
    @include display-flex();
    @include flex-direction(column);
    @include align-items(center);
    @include justify-content(center);
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    padding: 8px;
    @include border-radius(4px);

    &__value {
        margin-bottom: -4px;
        font-family: $text-bold;
        font-size: 1.5rem;
        line-height: normal;
    }

    &__label {
        font-family: $text;
        font-size: 0.875rem;
        line-height: normal;
    }

    &--warning {
        background-color: $warning-t90;
        color: $warning;

        .quantity-badge__value {
            color: $warning;
        }
        .quantity-badge__label {
            color: #5c5e61;
        }
    }

    &--error {
        background-color: $error-t90;
        color: $error-dark;

        .quantity-badge__value {
            color: $error-dark;
        }
        .quantity-badge__label {
            color: #5c5e61;
        }
    }
}
</style>
